module.exports = __webpack_public_path__ + "img/wqcl1.f9cc665d.png";